import React from 'react';

const TabsLayout = ({ children }) => <div className="ws-ui-tabs">{children}</div>;

export default TabsLayout;
